// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProductSearchPage_CurrentMaterialQueryVariables = Types.Exact<{
  productTliId: Types.Scalars['ID']['input'];
  versionId: Types.Scalars['ID']['input'];
}>;


export type ProductSearchPage_CurrentMaterialQuery = { __typename?: 'Query', takeoffLineItem: { __typename?: 'TakeoffLineItem', id: string, isDisabledMaterialVariant: boolean, materialVariant?: { __typename?: 'MaterialVariant', id: string } | null | undefined } };


export const ProductSearchPage_CurrentMaterialDocument = gql`
    query ProductSearchPage_CurrentMaterial($productTliId: ID!, $versionId: ID!) {
  takeoffLineItem(id: $productTliId, versionId: $versionId) {
    id
    materialVariant {
      id
    }
    isDisabledMaterialVariant
  }
}
    `;

/**
 * __useProductSearchPage_CurrentMaterialQuery__
 *
 * To run a query within a React component, call `useProductSearchPage_CurrentMaterialQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductSearchPage_CurrentMaterialQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductSearchPage_CurrentMaterialQuery({
 *   variables: {
 *      productTliId: // value for 'productTliId'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useProductSearchPage_CurrentMaterialQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProductSearchPage_CurrentMaterialQuery, ProductSearchPage_CurrentMaterialQueryVariables> & ({ variables: ProductSearchPage_CurrentMaterialQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProductSearchPage_CurrentMaterialQuery, ProductSearchPage_CurrentMaterialQueryVariables>(ProductSearchPage_CurrentMaterialDocument, options);
      }
export function useProductSearchPage_CurrentMaterialLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProductSearchPage_CurrentMaterialQuery, ProductSearchPage_CurrentMaterialQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProductSearchPage_CurrentMaterialQuery, ProductSearchPage_CurrentMaterialQueryVariables>(ProductSearchPage_CurrentMaterialDocument, options);
        }
export function useProductSearchPage_CurrentMaterialSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProductSearchPage_CurrentMaterialQuery, ProductSearchPage_CurrentMaterialQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProductSearchPage_CurrentMaterialQuery, ProductSearchPage_CurrentMaterialQueryVariables>(ProductSearchPage_CurrentMaterialDocument, options);
        }
export type ProductSearchPage_CurrentMaterialQueryHookResult = ReturnType<typeof useProductSearchPage_CurrentMaterialQuery>;
export type ProductSearchPage_CurrentMaterialLazyQueryHookResult = ReturnType<typeof useProductSearchPage_CurrentMaterialLazyQuery>;
export type ProductSearchPage_CurrentMaterialSuspenseQueryHookResult = ReturnType<typeof useProductSearchPage_CurrentMaterialSuspenseQuery>;
export type ProductSearchPage_CurrentMaterialQueryResult = Apollo.QueryResult<ProductSearchPage_CurrentMaterialQuery, ProductSearchPage_CurrentMaterialQueryVariables>;